import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Map from "../../components/Map/ReflectionLocationDashboard";
import GenericCard from "../../components/Card/CardGenric";
import { serverUrl } from "../../components/Helpers/Config";
import { tokenAuthorize, analyticsView } from "../../components/Helpers/Common";
import "chart.js";
import { Pie, Doughnut, Bar, Radar } from "react-chartjs-2";
import { faker } from "@faker-js/faker";
import { Progress } from "react-sweet-progress";
import {
  BgComment,
  BgWhite,
  ButtonCommonTop,
  Card,
  MenuItemCard,
  MenuItemDiv,
  TextGray,
} from "../Theme";
import "react-sweet-progress/lib/style.css";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import noDataAvailableImg from "../../common/images-new/no-data-available.png";
import { staticFiles } from "../../components/Helpers/Static";
import {
  ButtonCommonTopNew,
  ButtonCommonTopGrey,
  ButtonCommonDelete,
  ActiveSpanColor,
  SideBarNormalCount,
} from "../../pages/Theme";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MarkDownContent from "../../pages/Journal/MarkDownContent";
import Tooltip from "@mui/material/Tooltip";
import { BsSortUpAlt } from "react-icons/bs";
import { BsSortDown } from "react-icons/bs";
import { CommonLoader } from "../../components/Button/Loader";

function CompetencyAnalytics() {
  const dispatch = useDispatch();
  const [selectGroup, setSelectGroup] = useState();
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setPageSize] = useState(5);
  const [competencyGroup, setCompetencyGroup] = useState([]);
  const [competencyChart, setCompetencyChart] = useState([]);
  const baseColors = ["#FF6385", "#FFCE55", "#4AC1C1", "#2084D4"];
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const analyticsCardsDetails = useSelector(
    (state) => state.analyticsReducer.card_details || []
  );
  const [maxCount, setMaxCount] = useState(0);
  useEffect(() => {
    setIsLoading(true);
    axios
      .get(serverUrl.AnalyticsCompetencyCards)
      .then((resp) => {
        if (resp.status === 200) {
          setCompetencyChart(resp?.data?.results);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        setIsLoading(false);
      });
    setIsLoading(true);
    axios
      .get(serverUrl.AnalyticsCompetencyGroups)
      .then((resp) => {
        if (resp.status === 200) {
          setCompetencyGroup(resp?.data?.results);
          setSelectGroup(resp?.data?.results[0]?.competency_group_id);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        tokenAuthorize(err?.response?.status);
      });
  }, []);
  useEffect(() => {
    const selectedGroup = competencyGroup?.find(
      (group) => group.competency_group_id === selectGroup
    );

    if (!selectedGroup) return;
    setMaxCount(
      Math.max(
        ...(selectedGroup?.value_titles?.map((item) => item?.count || 0) || [0])
      )
    );
    const sortedValueTitles = [...selectedGroup.value_titles].sort((a, b) => {
      if (sortOrder === "asc") {
        return a?.count - b?.count;
      } else {
        return b?.count - a?.count;
      }
    });
    if (pageSize === "All") {
      setFilteredData(sortedValueTitles);
    } else {
      const paginated = sortedValueTitles.slice(0, pageSize); // take only pageSize items
      setFilteredData(paginated);
    }
  }, [selectGroup, competencyGroup, sortOrder, pageSize]);

  //   const splitEveryTwoWords = (text) => {
  //     const words = text?.split(" ");
  //     if (words.length === 2) {
  //       const combinedLength = text.length;
  //       // threshold can be tuned (e.g., 15 chars)
  //       if (combinedLength <= 13) {
  //         return [text]; // keep together
  //       } else {
  //         return [words[0], words[1]]; // split
  //       }
  //     }
  //     const lines = [];
  //     for (let i = 0; i < words?.length; i += 2) {
  //       lines.push(words?.slice(i, i + 2)?.join(" "));
  //     }
  //     return lines;
  //   };

  //   const splitEveryTwoWords = (text, maxLength = 13) => {
  //     if (!text) return [];

  //     const words = text.split(" ");
  //     const lines = [];

  //     for (let i = 0; i < words.length; i += 2) {
  //       const pair = words.slice(i, i + 2);
  //       const combined = pair.join(" ");

  //       if (pair.length === 2 && combined.length > maxLength) {
  //         // too long → break them separately
  //         lines.push(pair[0]);
  //         lines.push(pair[1]);
  //       } else {
  //         lines.push(combined);
  //       }
  //     }

  //     return lines;
  //   };
  const splitEveryTwoWords = (text, maxLength = 14) => {
    if (!text) return [];

    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    for (const word of words) {
      if ((currentLine + " " + word).trim().length <= maxLength) {
        // add word to current line
        currentLine = (currentLine + " " + word).trim();
      } else {
        // push current line and start new one
        if (currentLine) lines.push(currentLine);
        currentLine = word;
      }
    }

    if (currentLine) lines.push(currentLine);
    return lines;
  };

  document.querySelectorAll(".flip-trigger").forEach((trigger) => {
    trigger.addEventListener("mousedown", function () {
      // Remove 'active' class from all cards
      document.querySelectorAll(".flip-card.active").forEach((card) => {
        card?.classList?.remove("active");
      });

      // Add 'active' class to the clicked card
      const card = this.closest(".flip-card");
      card?.classList?.add("active");

      //Remove it after 5 seconds
      // setTimeout(() => {
      //     card.classList.remove('active');
      // }, 5000);
    });
  });
  document.querySelectorAll(".flip-triggerClosed").forEach((trigger) => {
    trigger.addEventListener("click", function () {
      // Remove 'active' class from all cards
      document.querySelectorAll(".flip-card.active").forEach((card) => {
        card?.classList?.remove("active");
      });
    });
  });

  return (
    <div className="w-full backGroundColor border20pxbottom pt-5 pb-5">
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {competencyChart?.map((category, index) => {
          const color = baseColors[index % baseColors.length];
          const labels = category?.children?.map((child) =>
            splitEveryTwoWords(child?.child_category_title)
          );
          const data = category?.children?.map((child) => child.value) || "";

          const chartData = {
            labels,
            datasets: [
              {
                label: category?.category_parent_title || "",
                data,
                fill: true,
                backgroundColor: color + "33",
                borderColor: color,
                pointBackgroundColor: color,
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: color,
              },
            ],
          };
          const options = {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                left: 15,
                right: 15,
                top: 15,
                bottom: 15,
              },
            },
            scale: {
              ticks: {
                display: false,
                beginAtZero: true,
                min: 0,
                max: 100,
                stepSize: 10,
                fontColor: "#999",
                backdropColor: "transparent",
              },
              angleLines: {
                display: false,
                color: "#fff",
              },
              pointLabels: {
                fontSize: 12,
                fontColor: "#666",
                callback: function (label) {
                  return label;
                },
              },
              gridLines: {
                circular: false,
              },
            },
            legend: {
              position: "top",
              display: false,
            },
            tooltips: {
              callbacks: {
                title: function () {
                  return ""; // hide the top title
                },
                label: function (tooltipItem) {
                  return `${
                    category?.children[tooltipItem.index]?.child_category_title
                  }: ${tooltipItem.yLabel}%`;
                },
              },
            },
          };
          return (
            <>
              <div key={index} className="flip-card h-100">
                <div className="flip-card-inner border20px shadow-sm cardBackgroundColor">
                  {/* Front */}
                  <div className="flip-card-front cardBackgroundColor">
                    {/* <div key={index} className="bg-white p-4 rounded-3xl shadow grid justify-items-center"> */}
                    <p className="blackColor text-xl font-semibold text-center">
                      {category?.category_parent_title}{" "}
                      <Tooltip title={analyticsView} placement="top" arrow>
                        <span>
                          <InfoIcon className="flip-trigger cursor-pointer primaryIcon" />
                        </span>
                      </Tooltip>
                    </p>
                    {category?.children[0]?.value == null ? (
                      <>
                        <div className="w-full flex items-center justify-center h-full">
                          <img
                            src={noDataAvailableImg}
                            alt="pics"
                            className="overflow-hidden w-52"
                          />
                        </div>
                      </>
                    ) : (
                      <div className="chart-content">
                        <Radar data={chartData} options={options} />
                      </div>
                    )}
                    <p className="text-sm lightColor mt-auto text-center">
                      How have I developed my {category?.category_parent_title}?
                    </p>
                    {/* </div> */}
                  </div>
                  {/* Back */}
                  <div className="flip-card-back bg-opacity-80">
                    <div className="">
                      <button className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold">
                        &times;
                      </button>
                      <h3 className="text-xl font-semibold blackColor mb-2">
                        {" "}
                        {category?.category_parent_title}
                      </h3>
                    </div>
                    <div className="overflow-y-auto custom-scrollbar">
                      <p className="text-sm text-justify pt-3 px-5">
                        {analyticsCardsDetails?.filter(
                          (x) => x.card_name == "ca_values_and_competencies"
                        )[0]?.is_html_content ? (
                          <MarkDownContent
                            htmlContent={
                              analyticsCardsDetails?.filter(
                                (x) =>
                                  x.card_name == "ca_values_and_competencies"
                              )[0]?.full_description
                            }
                            className={false}
                          />
                        ) : (
                          analyticsCardsDetails?.filter(
                            (x) => x.card_name == "ca_values_and_competencies"
                          )[0]?.full_description
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
        {isLoading || competencyChart?.length == 0 ? (
          <>
            <div key={2} className="flip-card h-100">
              <div className="flip-card-inner border20px shadow-sm cardBackgroundColor">
                {/* Front */}
                <div className="flip-card-front">
                  <p className="blackColor text-xl font-semibold text-center">
                    Values and Competencies{" "}
                    <Tooltip title={analyticsView} placement="top" arrow>
                      <span>
                        <InfoIcon className="flip-trigger cursor-pointer primaryIcon" />
                      </span>
                    </Tooltip>
                  </p>
                  {isLoading ? (
                    <div className="w-full flex items-center justify-center h-full">
                      <CommonLoader />
                    </div>
                  ) : (
                    competencyChart?.length == 0 && (
                      <>
                        <div className="w-full flex items-center justify-center h-full">
                          <img
                            src={noDataAvailableImg}
                            alt="pics"
                            className="overflow-hidden w-52"
                          />
                        </div>
                      </>
                    )
                  )}
                  <p className="text-sm lightColor mt-auto text-center">
                    {
                      analyticsCardsDetails?.filter(
                        (x) => x.card_name == "ca_values_and_competencies"
                      )[0]?.simple_description
                    }
                  </p>
                </div>
                {/* Back */}
                <div className="flip-card-back bg-opacity-80">
                  <div className="">
                    <button className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold">
                      &times;
                    </button>
                    <h3 className="text-xl blackColor font-semibold mb-2">
                      {" "}
                      Values and Competencies
                    </h3>
                  </div>
                  <div className="overflow-y-auto custom-scrollbar">
                    <p className="text-sm text-justify pt-3 px-5">
                      {analyticsCardsDetails?.filter(
                        (x) => x.card_name == "ca_values_and_competencies"
                      )[0]?.is_html_content
                        ? analyticsCardsDetails?.filter(
                            (x) => x.card_name == "ca_values_and_competencies"
                          )[0]?.full_description
                        : analyticsCardsDetails?.filter(
                            (x) => x.card_name == "ca_values_and_competencies"
                          )[0]?.full_description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div key={3} className="flip-card h-100">
          <div className="flip-card-inner border20px shadow-sm cardBackgroundColor">
            {/* Front */}
            <div className="analytics flip-card-front cardBackgroundColor">
              <div className="flex flex-wrap justify-between">
                <p className="blackColor text-xl font-semibold">
                  {filteredData?.length !== 0 ? (
                    <>
                      {competencyGroup
                        ?.filter(
                          (group) => group.competency_group_id === selectGroup
                        )[0]
                        ?.name?.toUpperCase()}
                    </>
                  ) : (
                    "Values"
                  )}
                  <Tooltip title={analyticsView} placement="top" arrow>
                    <span>
                      <InfoIcon
                        className="flip-trigger ml-1 cursor-pointer primaryIcon"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </span>
                  </Tooltip>
                </p>
                {filteredData?.length !== 0 && (
                  <>
                    <div className="flex gap-1.5">
                      {filteredData?.length !== 0 && (
                        <>
                          <div
                            className="flex cursor-pointer"
                            onClick={() => {
                              setSortOrder(sortOrder == "asc" ? "desc" : "asc");
                            }}
                          >
                            {sortOrder == "asc" ? (
                              <>
                                <Tooltip
                                  title={"Click to sort by descending"}
                                  placement="top"
                                  arrow
                                >
                                  <span>
                                    <BsSortUpAlt className="w-6 h-6 primaryIcon" />
                                  </span>
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                <Tooltip
                                  title={"Click to sort by ascending"}
                                  placement="top"
                                  arrow
                                >
                                  <span>
                                    <BsSortDown className="w-6 h-6 primaryIcon" />
                                  </span>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </>
                      )}
                      <FormControl className="w-full rounded-full-tab h-7">
                        <Select
                          value={pageSize || ""}
                          onChange={(e) => setPageSize(e.target.value)}
                          displayEmpty
                          size="small"
                          fullWidth
                          className="h-7"
                          inputProps={{ "aria-label": "Without label" }}
                          sx={{
                            "& .MuiSelect-select": {
                              padding: "0px 25px 3px 8px !important",
                            },
                            "& .MuiSvgIcon-root": {
                              right: "0px !important",
                            },
                          }}
                          MenuProps={{
                            disableScrollLock: true,
                          }}
                        >
                          <MenuItem className="DropDownFont" value={"All"}>
                            <MenuItemDiv className="blackColor">
                              All
                            </MenuItemDiv>
                          </MenuItem>

                          <MenuItem className="DropDownFont" value={5}>
                            <MenuItemDiv className="blackColor">5</MenuItemDiv>
                          </MenuItem>
                          <MenuItem className="DropDownFont" value={10}>
                            <MenuItemDiv className="blackColor">10</MenuItemDiv>
                          </MenuItem>
                        </Select>
                      </FormControl>
                      {/* <select
                                            id="yearSelect"
                                            className="px-2 h-7 border-2 border-gray-300 rounded focus:outline-none"
                                            defaultValue={pageSize}
                                            onChange={(e) => setPageSize(e.target.value)}
                                            value={pageSize}
                                        >
                                            <option key={1} value={'All'}>
                                                All
                                            </option>
                                            <option key={2} value={5}>
                                                5
                                            </option>
                                            <option key={3} value={10}>
                                                10
                                            </option>
                                        </select> */}
                    </div>
                  </>
                )}
              </div>
              {isLoading && (
                <div className="w-full flex items-center justify-center h-full">
                  <CommonLoader />
                </div>
              )}
              {!isLoading && filteredData?.length == 0 && (
                <div className="w-full flex items-center justify-center h-full">
                  <img
                    src={noDataAvailableImg}
                    alt="pics"
                    className="overflow-hidden w-52"
                  />
                </div>
              )}
              {filteredData?.length !== 0 && (
                <>
                  <ul className="pl-5 list-disc my-3 overflow-y-auto custom-scrollbarValuesandCompetencies pr-1.5">
                    {filteredData?.map((item, index) => {
                      const count = item?.count || 0;
                      const percent = maxCount ? (count / maxCount) * 100 : 0;
                      return (
                        <li key={index} className="grid grid-cols-2 gap-4 py-2">
                          <li className="lightColor text-sm">
                            {item.value_title}
                          </li>
                          <Progress
                            percent={percent || "0"}
                            status="success"
                            theme={{
                              success: {
                                symbol: `${item?.count || 0}`,
                              },
                            }}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </>
              )}
              <div
                className={`flex gap-2 flex-wrap px-5 mt-auto justify-center ${
                  filteredData?.length !== 0 && "pt-2"
                }`}
              >
                {filteredData?.length !== 0 && (
                  <>
                    {competencyGroup?.map((i, index) => (
                      <>
                        {/* // <ButtonChatBot
                                            //     key={index + 1}
                                            //     text={i?.name?.toUpperCase()}
                                            //     color="white"
                                            //     style={`border-2 h-10 font-normal text-sm rounded-3xl px-2 ${selectGroup == i.competency_group_id ? 'bg-gray-200' : ''}`}
                                            //     onClick={() => { setSelectGroup(i.competency_group_id) }}
                                            // ></ButtonChatBot> */}
                        {selectGroup == i.competency_group_id ? (
                          <ButtonCommonTopNew
                            className="px-2 border p-1 text-xs rounded-lg cursor-pointer"
                            onClick={() => {
                              setSelectGroup(i.competency_group_id);
                            }}
                          >
                            {i?.name?.toUpperCase()}
                          </ButtonCommonTopNew>
                        ) : (
                          <ButtonCommonTopGrey
                            className="px-2 border p-1 text-xs rounded-lg cursor-pointer"
                            onClick={() => {
                              setSelectGroup(i.competency_group_id);
                              setSortOrder("desc");
                            }}
                          >
                            {i?.name?.toUpperCase()}
                          </ButtonCommonTopGrey>
                        )}
                      </>
                    ))}
                  </>
                )}
                <p className="text-sm lightColor w-full mt-auto text-center">
                  {
                    analyticsCardsDetails?.filter(
                      (x) => x.card_name == "ca_values"
                    )[0]?.simple_description
                  }
                </p>
              </div>
            </div>
            {/* Back */}
            <div className="flip-card-back bg-opacity-8">
              <div className="">
                <button className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold">
                  &times;
                </button>
                <h3 className="text-xl font-semibold blackColor mb-2">
                  {filteredData?.length !== 0
                    ? competencyGroup
                        ?.filter(
                          (group) => group.competency_group_id === selectGroup
                        )[0]
                        ?.name?.toUpperCase()
                    : "Values"}
                </h3>
              </div>
              <div className="overflow-y-auto custom-scrollbar">
                <p className="text-sm text-justify pt-3 px-5">
                  {analyticsCardsDetails?.filter(
                    (x) => x.card_name == "ca_values"
                  )[0]?.is_html_content ? (
                    <MarkDownContent
                      htmlContent={
                        analyticsCardsDetails?.filter(
                          (x) => x.card_name == "ca_values"
                        )[0]?.full_description
                      }
                      className={false}
                    />
                  ) : (
                    analyticsCardsDetails?.filter(
                      (x) => x.card_name == "ca_values"
                    )[0]?.full_description
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompetencyAnalytics;
